import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './LineChart.style.scss';
import { useMediaQuery, useTheme } from '@mui/material';
import { TLineGraph } from '@/features/profile/types/profile.types';
import { selectIsLoadingDashboard, selectIsLoadingLineChartAbonnement, selectIsLoadingLineChartResiliation } from '@/store/reducers/dashboard/dashboard.selector';
import { ConnectedProps, connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

/* ===================================================================== */
//  On créer un props pour recevoir les valeurs a afficher dans le graph
/* ===================================================================== */
type TLineChartProps = {
    chartObject: TLineGraph | null,
    numeroGraph?: number | undefined,
    title?: string,
    isLineChartResiliationLoading?: boolean,
    isLineChartAbonnementLoading?: boolean
};

type TBiggerProps = {
    isBigger?: boolean
}

type PropsFromRedux = ConnectedProps<typeof connector>;

/*** End props  */
const LineChartFct: React.FC<TLineChartProps & TBiggerProps & PropsFromRedux> = ({
    chartObject,
    numeroGraph,
    title,
    isBigger,
    loading,
    isLineChartResiliationLoading,
    isLineChartAbonnementLoading
}) => {

    const [optionHighcharts, setOptionHighcharts] = useState({});
    // const lineChartOption : any = useRef(null);
    const theme = useTheme();
    const matches_down_lg = useMediaQuery(theme.breakpoints.down('lg'));
    const matches_down_sm = useMediaQuery(theme.breakpoints.down('sm'));

    Highcharts.setOptions({
        lang: {
            resetZoom: 'Reinitialiser le zoom'
        }
    });

    const options = {
        
        chart: {
            type: 'spline',
            zoomType: 'xy',
            height: matches_down_lg ? (matches_down_sm ? '100%' : '45%') : '55%'
        },
        resetZoomTitle: 'Test',
        title: {
            text: title
        },
        legend: {
            layout: 'horizontal',
        },
        xAxis: [
            {
                categories: chartObject?.absisse,
            },
        ],

        yAxis: [
            {
                title: {
                    text: 'Nombre'
                },
                gridLineWidth: 0.3
            },
            {
                title: {
                    text: 'Taux'
                },
                labels: {
                    format: '{value} %',
                },
                gridLineWidth: 1,
                opposite: true
            },
        ],
        plotOptions: {
            spline: {
                dataLabels: {
                    enabled: false
                },
                states: {
                    hover: {
                        lineWidth: 2
                    }
                },
                marker: {
                    enabled: false
                },
                // enableMouseTracking: true
            }
        },
        series: [
            {
                name: 'Dépôt de garantie encaissés ',
                color: '#94e1b1',
                yAxis: 0,
                lineWidth: 3,
                data: chartObject?.encaisse
            },
            {
                name: numeroGraph === 1 ? 'Nouveau abonnés' : 'Abonnés resiliés',
                yAxis: 0,
                color: '#e88011',
                lineWidth: 3,
                data: chartObject?.abonnes
            },
            {
                name: 'Taux',
                yAxis: 1,
                color: '#6f99e8',
                lineWidth: 3,
                data: chartObject?.taux
            }
        ],
        exporting: {
            enabled: true,
            scale: 2,
        },
        credits: {
            enabled: false
        }
    }

    const refreshHigchartGraph = () => {
        setOptionHighcharts(options);
    }


    useEffect(() => {

        // console.log(" chartObject ",chartObject,"numeroGraph",numeroGraph);
        refreshHigchartGraph();

        //eslint-disable-next-line    
    }, [loading]);



    return (
        <div className='line-chart-container'>
            {/* {numeroGraph} */}
            <>

                {
                    numeroGraph === 1 && (
                    
                    !isLineChartAbonnementLoading ?
                        (
                            <>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    allowChartUpdate={true}
                                    options={optionHighcharts}
                                />
                            </>
                        )
                        :
                        (
                            <div className='skeleton-chart'>
                                <img src={require('@/assets/images/gif/chart-load.gif')} alt="load" />
                            </div>
                        )
                    )
                }

                {
                    numeroGraph === 2 && (
                    
                       !isLineChartResiliationLoading ?
                        ( 
                            // setTimeout(() => {
                                <>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    allowChartUpdate={true}
                                    options={optionHighcharts}
                                />
                            </>
                            // }, 2000)
                           
                        )
                        :
                        (
                            <div className='skeleton-chart'>
                                <img src={require('@/assets/images/gif/chart-load.gif')} alt="load" />
                            </div>
                        )
                    )
                }

                {/* <button type='button' onClick={ (e) => {
                    setDisplayChart(false);
        
                    setTimeout(() => {
                        setDisplayChart(true); 
                    }, 200);
                } }> Redraw</button> */}
            </>
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    loading: selectIsLoadingDashboard,
    isLineChartResiliationLoading: selectIsLoadingLineChartResiliation,
    isLineChartAbonnementLoading: selectIsLoadingLineChartAbonnement 
});


const connector = connect(mapStateToProps);
const LineChart = connector(LineChartFct);



export default LineChart